// NFTDetail.js
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ProductAttribute from "../utility/product-attribute";
import ProductAccordion from "../utility/product-accordion";
import ProductDetail from "../utility/product-detail";
import Ptdc from "../utility/ptdc";
import { ChevronLeftIcon } from "@heroicons/react/24/solid";

const MetadataDisplay = ({ metadata }) => {
  if (!metadata) return null;

  const renderValue = (value) => {
    if (value === null || value === undefined) return null;

    if (typeof value === "string" && value.match(/^\d{4}-\d{2}-\d{2}/)) {
      const date = new Date(value);
      if (!isNaN(date.getTime())) {
        return date.toLocaleDateString();
      }
    }

    if (typeof value === "boolean") {
      return value ? "Yes" : "No";
    }

    if (Array.isArray(value)) {
      return value.map((item, index) => (
        <div key={index} className="mb-2 pl-2">
          {typeof item === "object" ? (
            renderObject(item)
          ) : (
            <span>{item.toString()}</span>
          )}
        </div>
      ));
    }

    if (typeof value === "object") {
      return renderObject(value);
    }

    return value.toString();
  };

  const renderObject = (obj) => {
    if (!obj) return null;

    return (
      <div className="outer-product-details-container">
        <div className="macro-details">
          <div className="product-details grid grid-cols-12 gap-4">
            {Object.entries(obj).map(([key, value]) => {
              const formattedKey = key
                .split("_")
                .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                .join(" ");

              return (
                <div
                  key={key}
                  className="col-span-12 sm:col-span-6 lg:col-span-4"
                >
                  <ProductDetail
                    label={formattedKey}
                    value={renderValue(value)}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  };

  const renderAttributes = (attributes) => {
    if (!attributes || !Array.isArray(attributes)) return null;

    return (
      <>
        <div className="grid grid-cols-12 gap-4 attributes-section">
          <div className="col-span-12">
            <h3>Attributi</h3>
          </div>
          {attributes.map((attr, idx) => (
            <div
              key={`${attr.trait_type}-${idx}`}
              className="col-span-12 sm:col-span-6 lg:col-span-4"
            >
              <ProductAttribute label={attr.trait_type} value={attr.value} />
            </div>
          ))}
        </div>
      </>
    );
  };

  const renderOtherMetadata = () => {
    const excludedFields = [
      "name",
      "description",
      "image",
      "external_url",
      "attributes",
    ];

    return Object.entries(metadata).map(([key, value]) => {
      if (excludedFields.includes(key)) return null;

      const formattedTitle = key
        .split("_")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");

      return (
        <ProductAccordion key={key} title={formattedTitle}>
          {renderValue(value)}
        </ProductAccordion>
      );
    });
  };

  return (
    <>
      {metadata.image && (
        <div className="col-span-12 outer-container">
          <div className="text-container">
            <div className="details-container">
              <div className="detail">ID:</div>
              <div className="detail">00/00</div>
            </div>
            <Ptdc
              // pretitle={"Tipologia: " + productData.type.value}
              title={metadata.name}
              description={metadata.description}
              size="medium"
            />
          </div>
          <div className="img-container">
            <img
              src={metadata.image}
              alt={metadata.name || "NFT"}
              className="absolute inset-0 w-full h-full object-contain"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/placeholder-image.jpg";
              }}
            />
          </div>
        </div>
      )}

      {metadata.attributes && (
        <>
          <div className="col-span-12">
            {renderAttributes(metadata.attributes)}
          </div>
        </>
      )}

      <div className="col-span-12">{renderOtherMetadata()}</div>
    </>
  );
};

const NFTDetail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { nft } = location.state || {};

  if (!nft) {
    navigate("/nft-gallery");
    return null;
  }

  return (
    <div className="nft-detail-page single-product container-cust mx-auto">
      <div className="back-button">
        <button onClick={() => navigate("/nft-gallery")}>
          <ChevronLeftIcon className="mr-2" />
        </button>

        <button
          onClick={() => navigate("/nft-gallery")}
          className="cta cta-standard"
        >
          back
        </button>
      </div>

      <div className="grid grid-cols-12 gap-4 header">
        <MetadataDisplay metadata={nft.metadata} />

        <div className="token-information-card col-span-12">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">
            Token Information
          </h3>
          <div className="token-information-row flex justify-between">
            <span className="text-gray-600">Token ID</span>
            <span className="font-medium">{nft.tokenId}</span>
          </div>
          <div className="token-information-row flex justify-between">
            <span className="text-gray-600">Token URI</span>
            <span className="font-medium break-all text-sm">
              {nft.tokenURI}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NFTDetail;
